import { render, staticRenderFns } from "./CmsRichText.vue?vue&type=template&id=f345c7d2"
import script from "./CmsRichText.vue?vue&type=script&lang=ts"
export * from "./CmsRichText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports